<template>
  <vk-modal :has-close-icon="closeIcon" @close="$emit('close')" >
    <template slot="header" :class="['bd-b-gray40', {closeIcon: 'p-l-6'}]" class="text-bold c-depot">
      <span class="c-black">Job Details</span>
    </template>
    <template  slot="content">
      <spinner v-if="!hasLoaded" class="m-x-auto m-y-6" size="100px" color="gray80"/>
      <transition v-else name="VERTICAL" mode="out-in">
        <div class="MODAL-CONTENT">
          <div class=" p-b-4 bd-b-gray40">
            <h2>{{workOrder.user.first_name}} {{workOrder.user.last_name}}</h2>
            <div class="TEXT-MED c-gray70 p-b-2">Received {{formatDate(job.time_created)}}</div>
            <div class="d-flex jc-center jc-start">
              <div class="TEXT-MED c-gray70 p-r-1">
                Job Status
              </div>
              <status-bubble
                  :status="bubbleStatus"
                  class="STATUS-BUBBLE"
              />
            </div>
          </div>
          <div class=" p-b-4 bd-b-gray40">
            <div class="TITLE">My Notes</div>
            <div>
              {{ note }}
            </div>
          </div>
          <div class="p-b-4 bd-b-gray40">
            <div class="TITLE">Appointments</div>
            <div v-if="hasAppointments">
              <div
                  class="p-b-1"
                  v-for="(appointment, index) in appointments"
                  :key="index"
              >
                <history-appointment :appointment="appointment"/>
              </div>
            </div>
            <div v-else>
              (None)
            </div>
          </div>
          <div class="d-flex fd-column p-y-4 bd-b-gray40 w-100">
            <div class="d-flex p-b-4">
              <div class="text-bold p-r-2">
                Job Details
              </div>
              <div>Job ID<span class="bg-gray30 p-x-1">{{job.user_friendly_identifier}}</span></div>
            </div>
            <div v-if="$device.isMobile">
              <div class="d-flex fd-column">
                <div class="p-b-4">
                  <div class="TITLE">Location</div>
                  <div>
                    {{workOrder.user.address.city}}
                    {{workOrder.user.address.state}}
                    {{workOrder.user.address.zipcode}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Customer Notes
                  </div>
                  <div>
                    {{workOrder.description || "(None)"}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Urgency
                  </div>
                  <div>
                    {{urgency}}
                  </div>
                  <div>
                    Received {{formatDate(workOrder.time_created)}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Photos
                  </div>
                  <div>
                    <gallery v-if="workOrder.attachments" :files="workOrder.attachments" class="p-b-2" />
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Lead Cost
                  </div>
                  <div>
                    {{leadCost}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Service
                  </div>
                  <div>
                    {{workOrder.service_display_name}}
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="d-flex">
              <div class="d-flex fd-column COLUMN p-r-5">
                <div class="p-b-4">
                  <div class="TITLE">
                    Location
                  </div>
                  <div>
                    {{workOrder.user.address.city}}
                    {{workOrder.user.address.state}}
                    {{workOrder.user.address.zipcode}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Urgency
                  </div>
                  <div>
                    {{urgency}}
                  </div>
                  <div>
                    Received {{formatDate(workOrder.time_created)}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">
                    Lead Cost
                  </div>
                  <div>
                    {{leadCost}}
                  </div>
                </div>
              </div>
              <div class="d-flex fd-column COLUMN">
                <div class="p-b-4">
                  <div class="TITLE">
                    Service
                  </div>
                  <div>
                    {{workOrder.service_display_name}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE">Customer Notes</div>
                  <div>
                    {{workOrder.description || "(Not Provided)"}}
                  </div>
                </div>
                <div class="p-b-4">
                  <div class="TITLE p-b-2">
                    Photos
                  </div>
                  <div v-if="workOrder.attachments.length">
                    <gallery v-if="workOrder.attachments" :files="workOrder.attachments" class="p-b-2" />
                  </div>
                  <div v-else>
                    (Not Provided)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="text-bold p-y-4 p-r-2">
              Customer Reviews
            </div>
            <div v-if="reviews.length" class=" ">
              <div
                  v-for="(review, index) in reviews"
                  :key="index"
                  class="text-md "
              >
                <review-with-pics :review="review" :isModal='true' />
              </div>
            </div>
            <div v-else>
              (None)
            </div>
          </div>
        </div>
      </transition>
    </template>
    <template slot="footer">
      <div class="d-flex fd-row-reverse jc-around:mo">
        <router-link
            :to="{
              name: 'dashboard::pro::jobs',
              params: {
                jobId: job.order_hash,
                jobsStatusAlias: jobStatusAlias,
              }
            }"
            class="BUTTON btn m-x-2"
            active-class="ACTIVE">
          View This Job
        </router-link>
      <button class="btn-tertiary BUTTON" @click="$emit('close')">Close</button></div>
    </template>
  </vk-modal>
</template>

<script>
import { getNotes } from '@homeservices/api-kit/workorder/pronotes';
import http from '@homeservices/api-kit/axios';
import { format } from 'date-fns';
import { mapActions, mapGetters } from 'vuex';
import appointments from '@/mixins/job/appointments';
import ReviewWithPics from '@/components/Reviews/ReviewWithPics';
import jobParams from '@/mixins/job-params';
import StatusBubble from '@/views/Dashboard/components/StatusBubble';
import workOrder from '@/mixins/work-order';
import HistoryAppointment from './HistoryAppointment';

export default {
  name: 'history-job-modal',
  getNotes,
  components: {
    StatusBubble,
    ReviewWithPics,
    HistoryAppointment,
  },
  mixins: [
    workOrder,
    appointments,
    jobParams,
  ],
  props: {
    closeIcon: {
      type: Boolean,
      default: true,
    },
    job: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      note: '(None)',
      hasLoaded: false,
      reviews: [],
    };
  },
  computed: {
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    hasAppointments () {
      return this.appointments.length > 0;
    },
    hasJob () {
      return !!this.job;
    },
    jobId () {
      return this.job.user_friendly_identifier;
    },
    currentMatch () {
      if (this.workOrder) {
        const jobMatch = this.workOrder.matches.filter((match) => {
          return this.job.work_order
            ? match.id === this.job.work_order.matches
            : match.id === this.job.matches;
        });
        return jobMatch[0];
      }
      return {};
    },
    bubbleStatus () {
      return this.currentMatch.match_status || null;
    },
    jobStatusAlias () {
      switch (this.currentMatch.match_status) {
        case 'new':
        case 'unreplied': {
          return 'new';
        }
        case 'potential': {
          return 'potential';
        }
        case 'hired': {
          return 'hired';
        }
        case 'completed': {
          return 'completed';
        }
        default: {
          return 'past';
        }
      }
    },
    leadCost () {
      return `${this.currentMatch.lead_cost} points`;
    },
  },
  async mounted () {
    await this.fetch();
  },

  methods: {
    ...mapActions('dashboard/workOrderMatches', [
      'fetchWorkOrderMatches',
    ]),
    ...mapActions('dashboard/workOrder', [
      'fetchWorkOrder',
    ]),
    ...mapActions('dashboard/workOrders', [
      'fetchWorkOrders',
      'resetWorkOrders',
    ]),
    formatDate (date) {
      return format(new Date(date), 'MMM dd yyyy');
    },
    async fetchNotes () {
      const { data } = await getNotes({
        order_hash: this.job.order_hash,
        service_provider_id: this.serviceProviderId,
      });
      this.note = data.total > 0 ? data.results[0].provider_notes : '(None)';
    },
    async fetchReviews () {
      const { data } = await http.get('/platform/coresearch/r/pro/reviews/v1', {
        params: {
          order_hashes: this.job.order_hash,
        },
      });
      this.reviews = data.total > 0 ? data.results : [];
    },
    async getAppointments () {
      await this.fetchAppointments({
        params: {
          size: 100,
          order_hash: this.job.order_hash,
          service_provider_id: this.serviceProviderId,
        },
      });
    },
    async fetch () {
      if (this.jobId) {
        await this.fetchWorkOrders({
          params: {
            order_hash: this.job.order_hash,
            size: 1,
          },
        });
        await Promise.all([
          this.getAppointments(),
          this.fetchNotes(),
          this.fetchReviews(),
        ]).then(() => {
          this.hasLoaded = true;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .TITLE {
    font-size: 18px;
    font-weight: 700;
  }
  .CONTENT {
    @include absolute(0, 0, 0, 0);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    background-color: white;
    box-shadow: 0 0 10px rgba(black, 0.2);
    overflow: hidden;

    @include tablet {
      position: relative;
      border-right: 1px solid $color-gray30;
      box-shadow: none;
    }

    @include desktop {
      overflow-x: auto;
      overflow-y: hidden;
    }
  }
  .TEXT-MED {
    font-size: 14px;
  }
  .CONTENT-CONTAINER {
    @include padding-bottom(0, 0, 9);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    overflow-y: scroll;
  }
  .BUTTON {
    width: $unit * 17;
  }
  .REVIEW {
    max-width: 58 * $unit;
  }
  .SECONDARY-CTA {
    position: sticky;
    bottom: 0;
    padding: 0;
  }
  .COLUMN {
    max-width : 28 * $unit;
  }
</style>
